import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { OtaId } from 'frontend-utils/utils/constants/constant-values';
import ApplicationSerializer from 'lumen/serializers/application';

interface ParityPayload {
  channel: OtaId;
  hotelinfo: number;
  max_persons: number;
  membershiptype: number;
  ota: string;
  // Added in serializer
  ota_hotel_info: string;
  period: string;
  platform: number;
  pos: string;
  screenshot_parity_id: string; // Added in serializer
}

interface NormalizedParityPayload {
  hotelinfo: number;
  maxPersons: number;
  membershiptype: number;
  ota: string;
  period: string;
  platform: number;
  pos: string;
  screenshotParityId: string;
}

interface ParityMeta {
  num_shops_major: number;
  num_shops_other: number;
  requested_platform: number;
}

export default class ParitySerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(typeClass: ModelSchema, hash: ParityPayload) {
    hash.ota_hotel_info = [hash.ota, hash.hotelinfo].join(',');
    hash.screenshot_parity_id = [
      hash.period,
      hash.hotelinfo,
      hash.ota,
      hash.platform,
      hash.pos,
      hash.membershiptype,
      hash.max_persons,
      hash.channel,
    ].join(',');

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }

  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: { meta: ParityMeta; parities: ParityPayload[] },
    id: string | number,
    requestType: string,
  ): { data: { attributes: NormalizedParityPayload }[]; meta: ParityMeta } {
    // Overwrite platform with the requested platform before normalizing until platform unspecified is deprecated in backend (PI-1660)
    payload.parities.forEach((parity) => {
      parity.platform = payload.meta.requested_platform;
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    ) as { data: { attributes: NormalizedParityPayload }[]; meta: ParityMeta };
  }
}
